// src/utils/helpers.ts

// Assuming Status is coming from your API and is an array of objects
// Example: [{ code: 'PENDING', name: 'Pending' }, ...]
export function globalHelper(s: string | undefined, Status: any[]): any | string {
  if (s && s !== 'undefined') {
    const found = Status.find(o => o.code === s);
    return found || '';
  }
  return '';
}
